var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-list"},[_c('img',{attrs:{"src":require("../../assets/images/search/icon-error-74.png"),"alt":"에러 아이콘"}}),_c('p',[_vm._v("해당데이터가 없습니다.")])])
}]

export { render, staticRenderFns }